<div class="distribution-plan">
    <div class="distribution-plan-background"></div>
    <div *ngIf="!loading" class="distribution-plan-container">
        <h1 class="distribution-plan-title">{{'Core.distributionPlan.title' | localize}}</h1>
        <div *ngIf="includeOutreach" class="distribution-plan-info">{{'Core.distributionPlan.info' | localize}}</div>
        <table class="distribution-plan-pricingTable">
            <thead>
                <tr>
                    <th>{{'Core.distributionPlan.recipients' | localize}}</th>
                    <th *ngFor="let header of pricing.headers">{{ header }}</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    class="distribution-plan-pricingTable-trWithBorder"
                    *ngFor="let row of pricing.rows"
                >
                    <td *ngFor="let price of row">{{ price }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
